export default __webpack_public_path__ + "static/media/glup-tickets-logo.8bfd2ff7.png";